/**
 * Holds reference to constants
 * or strings throughout the content
 */
export default {
  fontSizes: {
    SMALL: "font-small",
    MEDIUM: "font-medium",
    LARGE: "font-large",
  },
};
